export const handleAntSelectSearch = (input, option) => {
  if (!option) return false;
  if (!option.label) return false;
  if (!input) return false;

  return option.label.toLowerCase().includes(input.toLowerCase());
};
